import type { AiSuggestion } from '@app/src/pages/Questionnaire/hooks/useFetchFileAiSuggestions'
import type { RequestItem } from '@app/src/types/resourceExplorer'
import { QuestionTypes } from '@app/src/wf-constants'

export const suggestedAnswerButtonInViewQueryKey = 'suggestedAnswerButtonInViewQueryKey'

export const suggestionIsSet = (
  suggestion: AiSuggestion | undefined,
  requestItem: RequestItem,
): suggestion is AiSuggestion => {
  if (!suggestion) return false

  const isFileQuestion = requestItem.questionType.name.toLowerCase() === QuestionTypes.File.toLowerCase()
  if (isFileQuestion) {
    return !suggestion.cannotAnswer && Boolean(suggestion.response?.trim().length)
  }

  if (suggestion.cannotAnswer && !requestItem.isRequired) return true
  if (requestItem.questionType.name.toLowerCase() === QuestionTypes.Options.toLowerCase()) {
    return Boolean(suggestion.selectedOptions?.length)
  }

  return Boolean(suggestion?.response?.trim().length)
}
